import React, {useRef, useState} from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";

import {
    Badge,
    Box,
    Button,
    IconButton,
    List,
    Popover as MuiPopover,
    Tooltip,
    Typography,
} from "@mui/material";
import {Bell} from "react-feather";

const Popover = styled(MuiPopover)`
  .MuiPaper-root {
    width: 300px;
    ${(props) => props.theme.shadows[1]};
    border: 1px solid ${(props) => props.theme.palette.divider};
  }
`;

const Indicator = styled(Badge)`
  .MuiBadge-badge {
    background: ${(props) => props.theme.header.indicator.background};
    color: ${(props) => props.theme.palette.common.white};
  }
`;

const NotificationHeader = styled(Box)`
  text-align: center;
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;


function NotificationsDropdown() {
    const ref = useRef(null);
    const [isOpen, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Tooltip title="Notifications">
                <IconButton color="inherit" ref={ref} onClick={handleOpen} size="large">
                    <Indicator badgeContent={0}>
                        <Bell/>
                    </Indicator>
                </IconButton>
            </Tooltip>
            <Popover
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                anchorEl={ref.current}
                onClose={handleClose}
                open={isOpen}
            >
                <NotificationHeader p={2}>
                    <Typography variant="subtitle1" color="textPrimary">
                        0 New Notifications
                    </Typography>
                </NotificationHeader>
                <React.Fragment>
                    <List disablePadding>

                    </List>
                    <Box p={1} display="flex" justifyContent="center">
                        <Button size="small" component={Link} to="#">
                            Show all notifications
                        </Button>
                    </Box>
                </React.Fragment>
            </Popover>
        </React.Fragment>
    );
}

export default NotificationsDropdown;
